import { useMemo } from 'react';
import { Outlet, useNavigate } from 'react-router';

import { queryClient } from '@/utils/trpc';
import { TaurusProvider } from '@infinex/ui/components';
import { MainServiceTrpcProvider, SessionProvider } from '@infinex/user';
import { HyperliquidProvider } from '@infinex/web-shared/api';
import { BalancesProvider } from '@infinex/web-shared/features/balances';

import { ConnectUserProvider } from './ConnectUserProvider';

import { client } from '../lib/client';

export function GlobalLogicContainer() {
  const navigate = useNavigate();
  const router = useMemo(() => ({ navigate }), [navigate]);
  return (
    <>
      <TaurusProvider router={router}>
        <MainServiceTrpcProvider trpcClient={client} queryClient={queryClient}>
          <SessionProvider>
            <ConnectUserProvider>
              <HyperliquidProvider updateThrottleInMs={1000}>
                <BalancesProvider manageAssetVisibilityHref={null}>
                  <Outlet />
                </BalancesProvider>
              </HyperliquidProvider>
            </ConnectUserProvider>
          </SessionProvider>
        </MainServiceTrpcProvider>
      </TaurusProvider>
    </>
  );
}
